import { all, takeLatest, call, put, fork } from "redux-saga/effects";
import { responseGetTimeOffRequestsAction, errorGetTimeOffRequestsAction, 
  TIMEOFF_ACTION, responseGetTimeOffByIdAction, errorGetTimeOffByIdAction, 
  responseUpdateTimeOffAction, errorUpdateTimeOffAction, responseCancelTimeOffAction, 
  errorCancelTimeOffAction, responseRequestTimeOffAction, errorRequestTimeOffAction,
  responseGetAllTimeOffRequestsUsingUserIdAction, errorGetAllTimeOffRequestsUsingUserIdAction } from "./TimeOffActionCreator";
import TimeOffService from "../../Services/RestApiManager/TimeOffManager/TimeOffService";



export function* getTimeOffRequestsRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.getTimeOffRequests, action.data);
    yield put(responseGetTimeOffRequestsAction(response));
  } catch (error) {
    yield put(errorGetTimeOffRequestsAction(error));
  }
}

export function* getTimeOffByIdRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.getTimeOffById, action.data);
    yield put(responseGetTimeOffByIdAction(response));
  } catch (error) {
    yield put(errorGetTimeOffByIdAction(error));
  }
}


export function* updateTimeOffRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.updateTimeOff, action.data);
    yield put(responseUpdateTimeOffAction(response));
  } catch (error) {
    yield put(errorUpdateTimeOffAction(error));
  }
}

export function* cancelTimeOffRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.cancelTimeOff, action.data);
    yield put(responseCancelTimeOffAction(response));
  } catch (error) {
    yield put(errorCancelTimeOffAction(error));
  }
}

export function* requestTimeOffRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.requestTimeOff, action.data);
    yield put(responseRequestTimeOffAction(response));
  } catch (error) {
    yield put(errorRequestTimeOffAction(error));
  }
}


export function* getAllTimeOffRequestsUsingUserIdRequest(action) {
  try {
    const response = yield call(TimeOffService.shared.getAllTimeOffWithoutPagination);
    yield put(responseGetAllTimeOffRequestsUsingUserIdAction(response));
  } catch (error) {
    yield put(errorGetAllTimeOffRequestsUsingUserIdAction(error));
  }
}

export function* timeOffWatcherSaga() {
  yield all([
    takeLatest(TIMEOFF_ACTION.REQUEST_GET_TIMEOFF_REQUESTS, getTimeOffRequestsRequest),
    takeLatest(TIMEOFF_ACTION.REQUEST_GET_TIMEOFF_BY_ID, getTimeOffByIdRequest),
    takeLatest(TIMEOFF_ACTION.REQUEST_UPDATE_TIMEOFF, updateTimeOffRequest),
    takeLatest(TIMEOFF_ACTION.REQUEST_CANCEL_TIMEOFF, cancelTimeOffRequest),
    takeLatest(TIMEOFF_ACTION.REQUEST_REQUEST_TIMEOFF, requestTimeOffRequest),
    takeLatest(TIMEOFF_ACTION.REQUEST_GET_ALL_TIMEOFF_REQUESTS_USING_USER_ID, getAllTimeOffRequestsUsingUserIdRequest),
  ]);
}

export default timeOffWatcherSaga;
